import React from "react";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import "src/assets/css/Carousel/ProductViewCarousel.css";
import { Skeleton } from "@mui/material";

interface IProps {
  title: string;
  data: any[];
  renderProduct: (product: any, index: number , id : string) => React.ReactNode;
  secondTitle?: string;
  className?: string;
  renderSkeleton?: React.ReactNode;
  isLoading?: boolean;
  id?:string;
  autoplayOptions?: {
    delay?: number;
    stopOnInteraction?: boolean;
    stopOnMouseEnter?: boolean;
  };
}

const ProductViewSection: React.FC<IProps> = ({
  title,
  data,
  renderProduct,
  secondTitle,
  className = "",
  renderSkeleton,
  isLoading,
  id,
  autoplayOptions = {
    delay: 3000,
    stopOnInteraction: false,
    stopOnMouseEnter: true
  }
}) => {
  const [emblaRef] = useEmblaCarousel({
    align: "start",
    containScroll: "trimSnaps",
    loop: false,
    dragFree: true,
  // });
  }, [Autoplay(autoplayOptions)]);

  return (
    <div className={`view-area-width mx-auto py-5 ${className}`}>
      <h2 className="text-center mb-5 font-size-35px font-Lexend-SemiBold theme-color-green">
        {isLoading ? <Skeleton variant="text" width={200} height={30} /> : title}
      </h2>
      {secondTitle && (
        <p className="font-Poppins-Regular -mt-5 mb-4 font-size-14px text-[#3B3B3B] text-center">
          {secondTitle}
        </p>
      )}
      <div className="pharma-embla" ref={emblaRef}>
        <div className="pharma-embla__container">
          {isLoading && Array.from({length : 6}).map((item, index) => (
            <div className="pharma-embla__slide" key={index}>
              {renderSkeleton && renderSkeleton}
            </div>
          ))}
          {!isLoading && data.map((item, index) => (
            <div className="pharma-embla__slide" key={index}>
              <div className="w-[calc(100%-5px)] 2xl:w-[calc(100%-15px)] h-full">
                {renderProduct(item, index , id || "")}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductViewSection;
